import { ColorVariables } from "manifest-components/src/Colors";
import styled from "styled-components";
import { useTypedLocation } from "../../routes/RoutePaths";

const StyledDebugger = styled.pre`
  position: fixed;
  bottom: 10px;
  right: 10px;
  height: 200px;
  width: 350px;
  font-size: 10px;
  border: 1px solid ${ColorVariables.mint};
  padding: 10px;
  overflow: scroll;
  z-index: 100;
`;

export default function LocationStateDebugger() {
  const { state } = useTypedLocation();

  return <StyledDebugger>{JSON.stringify(state || {}, null, 2)}</StyledDebugger>;
}
